// export const SOCKET_BASE_URL = "ws://6669-103-181-64-181.ngrok-free.app/ws/algosocket"
const loginKey = localStorage.getItem("session-token")
export const SOCKET_BASE_URL = `wss://api.algocontroller.com/wss/algosocket`


